/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

// Import crypto polyfill FIRST, before any other imports
import './utils/cryptoPolyfill';

import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './helpers';
import { Amplify } from 'aws-amplify';
import { initializeStorageKeys } from './helpers/storageUtils';
import 'font-awesome/css/font-awesome.min.css';
import { registerLicense } from '@syncfusion/ej2-base';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { msalConfigProd } from './authConfigProd';
import { commonConstants } from './constants';
// config and config_old are injected by webpack DefinePlugin based on environment
let msalInstance = null;

// Check if we're in a secure context (HTTPS or localhost)
const isSecureContext =
  globalThis.isSecureContext ||
  globalThis.location.protocol === 'https:' ||
  globalThis.location.hostname === 'localhost' ||
  globalThis.location.hostname === '127.0.0.1';

if (!isSecureContext) {
  console.warn(
    'Application is not running in a secure context. MSAL may not work properly. Please use HTTPS or localhost.'
  );
}

// Function to check if crypto is available
function isCryptoAvailable() {
  return (
    typeof window !== 'undefined' &&
    window.crypto &&
    window.crypto.getRandomValues &&
    window.crypto.subtle
  );
}

// Initialize MSAL only if crypto is available
if (isCryptoAvailable()) {
  try {
    if (commonConstants.IS_PRODUCTION_SITE) {
      msalInstance = new PublicClientApplication(msalConfigProd);
    } else {
      msalInstance = new PublicClientApplication(msalConfig);
    }
  } catch (error) {
    console.error('Failed to initialize MSAL:', error);
    if (error.message && error.message.includes('crypto_nonexistent')) {
      console.error(
        'Crypto API is not available. Please ensure you are running on HTTPS or localhost.'
      );
    }
  }
} else {
  console.warn(
    'Crypto API not available. MSAL will not be initialized. Please use HTTPS or localhost for full functionality.'
  );
}

(function () {
  if (window.location.href.includes('autire.ai/')) {
    let head = document.getElementsByTagName('head')[0];
    let js = document.createElement('script');
    js.type = 'text/javascript';
    js.language = 'javascript';
    js.async = true;
    js.src =
      'https://cdn.whatfix.com/prod/385db3e5-85dd-4215-9b40-3140d845557c/initiator/initiator.nocache.js';
    head.appendChild(js);
  }
})();

if (localStorage.getItem('login_option') && localStorage.login_option == 'new') {
  Amplify.configure(config);
} else {
  Amplify.configure(config_old);
}

registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9eeHRRRmRcUEN3X0dWYEA='
);

// Initialize storage keys on app load
initializeStorageKeys();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App msalInstance={msalInstance} />
  </Provider>
);

serviceWorker.unregister();
